import React from "react";
import { IMAGES } from "../../utils/images";

const QuickScanSection = () => {
    return (
        <section className="bg-[#f8f8fa]">
            <div className="max-w-[1200px] mx-auto px-[16px] md:px-[40px] py-[56px] md:py-[80px]">
                <div className="bg-white rounded-[20px] border border-[#e4e5e7] overflow-hidden shadow-[0px_4px_24px_rgba(0,0,0,0.06)]">
                    <div className="grid grid-cols-1 lg:grid-cols-2">

                        {/* Image */}
                        <div className="relative min-h-[300px] lg:min-h-0">
                            <img
                                src={IMAGES.aboutQuickScan}
                                alt="Scanning QR code"
                                className="absolute inset-0 w-full h-full object-cover"
                            />
                            {/* <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent lg:bg-gradient-to-r" /> */}
                        </div>

                        {/* Content */}
                        <div className="p-[32px] md:p-[48px] flex flex-col justify-center">
                            <div className="inline-flex items-center gap-[6px] px-[12px] py-[5px] rounded-full bg-[#fff0ec] mb-[20px] w-fit">
                                <span className="font-semibold text-[11px] text-[#ff5323] uppercase tracking-[0.5px]">
                                    QuickScan
                                </span>
                            </div>

                            <h3 className="font-semibold text-[22px] md:text-[26px] text-[#212326] mb-[12px]">
                                Already at the shop? Upload in 5 seconds.
                            </h3>

                            <p className="font-medium text-[15px] text-[#717182] leading-[1.7] mb-[24px]">
                                Every listed shop gets a unique QR code they can print and display at their counter.
                                Customers scan it and upload files instantly - no friction.
                            </p>

                            <div className="flex flex-col gap-[14px] mb-[28px]">
                                <div className="flex items-start gap-[12px]">
                                    <div className="w-[36px] h-[36px] rounded-[10px] bg-[#fff0ec] flex items-center justify-center shrink-0">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                            class="lucide lucide-qr-code w-[18px] h-[18px] text-[#ff5323]">
                                            <rect width="5" height="5" x="3" y="3" rx="1"></rect>
                                            <rect width="5" height="5" x="16" y="3" rx="1"></rect>
                                            <rect width="5" height="5" x="3" y="16" rx="1"></rect>
                                            <path d="M21 16h-3a2 2 0 0 0-2 2v3"></path>
                                            <path d="M21 21v.01"></path>
                                            <path d="M12 7v3a2 2 0 0 1-2 2H7"></path>
                                            <path d="M3 12h.01"></path>
                                            <path d="M12 3h.01"></path>
                                            <path d="M12 16v.01"></path>
                                            <path d="M16 12h1"></path>
                                            <path d="M21 12v.01"></path>
                                            <path d="M12 21v-1"></path>
                                        </svg>
                                    </div>
                                    <div>
                                        <p className="font-semibold text-[14px] text-[#212326] mb-[2px]">For shops</p>
                                        <p className="font-medium text-[13px] text-[#717182] leading-[1.5]">Download your branded QR code from the dashboard. Print it, frame it, stick it on your counter or shopfront window.</p>
                                    </div>
                                </div>
                                <div className="flex items-start gap-[12px]">
                                    <div className="w-[36px] h-[36px] rounded-[10px] bg-[#fff0ec] flex items-center justify-center shrink-0">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-smartphone w-[18px] h-[18px] text-[#ff5323]">
                                            <rect width="14" height="20" x="5" y="2" rx="2" ry="2"></rect>
                                            <path d="M12 18h.01"></path>
                                        </svg>
                                    </div>
                                    <div>
                                        <p className="font-semibold text-[14px] text-[#212326] mb-[2px]">For customers</p>
                                        <p className="font-medium text-[13px] text-[#717182] leading-[1.5]">Open your phone camera, scan the code, upload your files. Or type the shop's 6-character code manually. It's that simple.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="flex items-center gap-[12px] px-[20px] py-[14px] rounded-[14px] bg-[#f8f8fa] border border-[#e4e5e7]">
                                <div className="w-[44px] h-[44px] rounded-[10px] bg-white border border-[#e4e5e7] flex items-center justify-center shrink-0">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-scan-line w-[20px] h-[20px] text-[#ff5323]">
                                        <path d="M3 7V5a2 2 0 0 1 2-2h2"></path>
                                        <path d="M17 3h2a2 2 0 0 1 2 2v2"></path>
                                        <path d="M21 17v2a2 2 0 0 1-2 2h-2"></path>
                                        <path d="M7 21H5a2 2 0 0 1-2-2v-2"></path>
                                        <path d="M7 12h10"></path>
                                    </svg>
                                </div>
                                <div>
                                    <p className="font-mono font-semibold text-[18px] text-[#ff5323] tracking-[4px]">JET001</p>
                                    <p className="font-medium text-[11px] text-[#9298a0]">Example shop code</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default QuickScanSection;
